export default __webpack_public_path__ + "static/media/img3.63efbc5d.jpg";